import type { Fixture, FixtureResponse } from "~types/fixture";

export const transformFixtureListResponse = (response: FixtureResponse) => {
  const resources = response?.includes?.resources;

  const getFixtureCompetitor = (fixture: Fixture, isHome: boolean) => {
    const competitor = fixture?.competitors?.filter((x: any) => x.isHome === isHome)?.[0];
    if (!competitor) {
      return null;
    }

    return {
      ...competitor,
      entity: response?.includes?.resources?.entities?.[competitor.entity.id],
    };
  };

  const getFixtureParticipants = (fixture: Fixture, isHome: boolean) => {
    return fixture?.participants
      ?.filter((x: any) => x.isHome === isHome)
      ?.map((participant: any) => {
        return {
          ...participant,
          person: response?.includes?.resources?.persons?.[participant.person.id],
        };
      });
  };

  return response?.data?.map((fixture: any) => {
    return {
      ...fixture,
      homeCompetitor: getFixtureCompetitor(fixture, true),
      awayCompetitor: getFixtureCompetitor(fixture, false),
      homeParticipants: getFixtureParticipants(fixture, true),
      awayParticipants: getFixtureParticipants(fixture, false),
      season: resources?.seasons?.[fixture.season?.id],
      venue: resources?.venues?.[fixture.venue?.id],
      stage: resources?.seasonStages?.[fixture.stage?.id],
      pool: resources?.seasonPools?.[fixture.pool?.id],
      series: resources?.seasonSeries?.[fixture.series?.id],
      round: resources?.seasonRounds?.[fixture.round?.id],
      fixtureProfile: resources?.fixtureProfiles?.[fixture.fixtureProfile?.id],
      startDate: fixture.startTimeLocal,
      startTime: fixture.startTimeLocal,
    };
  });
};
